import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { IBrand } from "@faire/web-api--source/indigofair/data/IBrand";
import { IPayoutTermEnum } from "@faire/web-api--source/indigofair/data/IPayoutTermEnum";

export const getBrand = (): IBrand | undefined => {
  return getGlobalProperty("brand");
};

export const getBrandToken = () => getBrand()?.token;

export const getBrandBusinessName = () => getBrand()?.name;

export const getBrandEmail = () => getBrand()?.email_address;

export const getBrandPayoutTerm = () => getBrand()?.payout_term;

export const hasPayoutTerm = (): boolean => {
  return (
    !!getBrandPayoutTerm() &&
    getBrandPayoutTerm() !== IPayoutTermEnum.PayoutTerm.UNSPECIFIED
  );
};

export const getBrandBasedIn = () => getBrand()?.based_in;

export const isLoggedInBrand = () => !!getBrandToken();
